import React from "react";
import { Select } from "antd";

const DEFAULT_CURRENCIES = [
    { code: "USD", symbol: "$", name: "US Dollar" },
    { code: "EUR", symbol: "€", name: "Euro" },
    { code: "GBP", symbol: "£", name: "British Pound" },
    { code: "INR", symbol: "₹", name: "Indian Rupee" },
    { code: "SGD", symbol: "S$", name: "Singapore Dollar" },
    { code: "AED", symbol: "د.إ", name: "UAE Dirham" },
    { code: "AUD", symbol: "A$", name: "Australian Dollar" },
    { code: "CAD", symbol: "C$", name: "Canadian Dollar" },
    { code: "JPY", symbol: "¥", name: "Japanese Yen" },
    { code: "CNY", symbol: "¥", name: "Chinese Yuan" },
];


const CurrencyDropdown = ({
    value,
    onChange,
    placeholder = "Select Currency",
    currencies = DEFAULT_CURRENCIES,
    style = { width: "100%" },
    disabled = false,
    allowClear = false,
}) => {
    return (
        <Select
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            style={style}
            disabled={disabled}
            allowClear={allowClear}
            showSearch
            optionFilterProp="label"
            options={currencies.map((currency) => ({
                value: currency.code,
                label: `${currency.code} (${currency.symbol}) - ${currency.name}`,
            }))}
        >
            {currencies.map((currency) => (
                <Select.Option
                    key={currency.code}
                    value={currency.code}
                >
                    {currency.code} ({currency.symbol}) - {currency.name}
                </Select.Option>
            ))}
        </Select>
    );
};

export const getCurrencySymbol = (currencyCode) => {
    const currency = DEFAULT_CURRENCIES.find(
        (item) => item.code === currencyCode
    );

    return currency?.symbol || currencyCode;
};

export default CurrencyDropdown;